import { StackScreenProps } from "@react-navigation/stack";
import React, { useState } from "react";

import { useViewport } from "@/contexts/ViewportContext";
import { useAppNavigation } from "@/hooks/application/navigation";
import { useCategoryListWithProducts } from "@/hooks/domain/productCategory";
import { useHallById, useStoreHalls } from "@/hooks/domain/storeHall";
import { HomeNavigation, HomeStackParamList } from "@/navigation/stacks/HomeStack";

import HallCategoryListMobile from "./HallCategoryList.mobile";
import HallCategoryListWeb from "./HallCategoryList.web";

type ScreenProps = StackScreenProps<HomeStackParamList, "hallCategoryList">;

const HallCategoryList = ({ route }: ScreenProps) => {
  const [hallId, setHallId] = useState(route.params?.hallId);

  const { isWebMode } = useViewport();

  const { navigate, goBack, setOptions } = useAppNavigation<HomeNavigation>();

  const { data: hall, isLoading: isLoadingHall } = useHallById(hallId, {
    onSuccess: (data) => {
      setOptions({ title: data?.nome });
    },
  });

  const { data: hallList } = useStoreHalls(hall?.estabelecimento, {
    enabled: !!hall?._id,
    onError: () => {
      goBack();
    },
  });

  const { data: categoryList, isLoading: isLoadingCategories } = useCategoryListWithProducts(
    hall?._id,
    {
      enabled: !!hall?._id,
    }
  );

  const onSelectHall = (hallId: string) => {
    setHallId(hallId);
  };

  const onPressViewMore = (categoryId: string) => {
    navigate("categoryProductList", { categoryId });
  };

  const onSelectProduct = (productId: string) => {
    navigate("product", { productId });
  };

  const Screen = isWebMode ? HallCategoryListWeb : HallCategoryListMobile;

  return (
    <Screen
      categoryList={categoryList}
      hall={hall}
      hallList={hallList}
      isLoading={isLoadingHall || isLoadingCategories}
      onPressViewMore={onPressViewMore}
      onSelectProduct={onSelectProduct}
      onGoBack={() => goBack()}
      onSelectHall={onSelectHall}
    />
  );
};

export default HallCategoryList;
